import evaluateJsonOutputValue from "./evaluateJsonOutputValue";
import evaluateOutputCalculation from "./evaluateOutputCalculation";

const evaluateRecursiveSumOutput = (recursiveSumOutputConfiguration, context, originalOutputField, skipContextCheck=false) => {
  const {recursive_question_id, output_id} = JSON.parse(recursiveSumOutputConfiguration);
  const recursive_question_value = context.responses[recursive_question_id]?.recursive_question_value || [];
  const recursiveOutput = context.configuration.find((d) => d.id === output_id);
  let total = 0
  for (let i = 0; i < recursive_question_value.length; i++) {
    switch (recursiveOutput.output_type) {
      case 'json_output_value':
        total += evaluateJsonOutputValue(recursiveOutput, context, i) || 0;
        break;
      case 'calculation':
        total += evaluateOutputCalculation(recursiveOutput,
          {
            ...context,
            responses: {
              ...context.responses,
              ...context.responses[recursive_question_id]?.recursive_question_value?.[i]
            }
          }
          , originalOutputField, i, skipContextCheck) || 0;
        break;
      default:
        throw Error(`output type ${recursiveOutput.output_type} not supported`);
    }
  }
  return total;
}

export default evaluateRecursiveSumOutput;